import { Button, Dropdown, Tabs } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { ArchivedCaseListContainer } from "./archived-case-list.container";
import React from "react";
import { ActiveCaseListCommonContainer } from "./active-case-list-common.container";
import { RelatedCaseListCommonContainer } from "./related-case-list-common.container";

interface RelatedCasesTabProps {
  //refetch: boolean | undefined;
  handleMenuClick: (e: any) => void;
  caseId: string;
  selectedId: string | null;
  disabled: boolean | undefined;
  applicantId: string;
}

export const RelatedCasesTab: React.FC<RelatedCasesTabProps> = (props) => {
  const [disabled, setDisabled] = React.useState<boolean | undefined>(props.disabled);

  const menuItems = [
    { key: "id-verification", label: "ID Verification" },
  ];
  const relatedCasesMenuItems = menuItems.map((item) => {
    return { key: item.key, label: item.label, onClick: props.handleMenuClick };
  });

  const paneTabs = [
    {
      key: '1',
      label: 'Related',
      children: (
        <>
          {/* <RelatedCaseListContainer applicantId={props.applicantId} caseId={props.caseId} setDisabled={setDisabled}/> */}
          <RelatedCaseListCommonContainer caseId={props.caseId} applicantId={props.applicantId} setDisabled={setDisabled}/>
        </>
      )
    },
    {
      key: '2',
      label: 'Active',
      children: (
        <>
          {/* <ActiveCaseListContainer isVerticalColumn={undefined} applicantId={props.applicantId} caseId={props.caseId} /> */}
          <ActiveCaseListCommonContainer applicantId={props.applicantId} isVerticalColumn={undefined} />
        </>
      )
    },
    {
      key: '3',
      label: 'Archived',
      children: (
        <>
          <ArchivedCaseListContainer caseId={props.caseId} applicantId={props.applicantId} isVerticalColumn={undefined} />
        </>
      )
    }
  ];
  return (
    <>
      <div style={{ marginTop: "-10px" }}>
        <Tabs defaultActiveKey="1" items={paneTabs}/>
      </div>
      <div style={{ marginTop: "16px", textAlign: "right" }}>
      <Dropdown menu={{items: relatedCasesMenuItems}} trigger={['hover']} disabled={props.disabled || disabled}>
          <Button>
            {props.selectedId ? "ID Verification" : "Add Related Case"}{" "}
            <DownOutlined />
          </Button>
        </Dropdown>
        
      </div>
    </>
  );
};
